function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKtxSancheonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "900.00165mm",
    height: "300mm",
    viewBox: "0 0 900.00165 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-6.257l-2.556-8.445c-.339-1.114-.26-2.066.222-2.864.487-.799 1.358-1.197 2.612-1.197h23.035l4.702 5.209H-2.213Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 604.138 138.825)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.213 7.307H-4.04l-6.741-22.253h6.253l2.951 9.733h4.166L4.169 0Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 714.155 81.468)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0a5.03 5.03 0 0 0-2.231 2.144c-.539.925-.768 2.273-.778 3.733-.013 1.46.304 3.256.951 5.396l.501 1.656h-5.491l-.501-1.656c-.647-2.14-1.425-3.936-2.338-5.396-.912-1.46-1.96-2.808-3.059-3.733-1.109-.953-2.285-1.67-3.533-2.144a16.88 16.88 0 0 0-3.541-.931l-1.473-4.862c2.574.308 5.679.966 7.991 1.979 2.407 1.054 4.524 2.738 6.342 5.046.389-2.308 1.46-3.992 3.218-5.046 1.657-.998 3.01-1.655 5.379-1.965L2.912-.911C1.825-.729.856-.426 0 0",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 658.138 105.326)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-6.253l-2.56-8.445c-.334-1.114-.259-2.066.225-2.864.486-.799 1.357-1.197 2.61-1.197h23.034l4.704 5.209H-2.208Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 780.603 138.825)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.214 7.307h6.257L1.728-14.946h-6.252l2.951 9.733h-4.171L-4.168 0Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 864.141 81.468)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-8.104l.95 3.127h-4.635L-12.736 0h-8.107l-1.578-5.212h8.108S-15.07-7.08-15.842-8.1c-.772-1.017-1.626-1.875-2.571-2.562a11.362 11.362 0 0 0-3.061-1.657 14.025 14.025 0 0 0-3.311-.751l-1.406-4.651c1.38.026 2.703.193 3.973.495 1.272.302 2.465.707 3.575 1.225a17.866 17.866 0 0 1 2.962 1.637c.43.302.827.608 1.189.922.171-.314.381-.62.629-.922.507-.603 1.158-1.148 1.969-1.637.801-.518 1.747-.923 2.833-1.225 1.09-.302 2.313-.469 3.677-.495l1.408 4.651c-1.047.113-2.001.364-2.857.751a5.106 5.106 0 0 0-2.056 1.657c-.525.687-.864 1.545-1.02 2.562-.151 1.02.226 2.888.226 2.888h8.109z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 854.517 55.005)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h13.479L1.375 27.413l-5.639-3.89 4.785 5.829-3.56 8.064h-50.672L-71.3 25.197l2.253 2.741 2.764 9.234h-13.482L-90.879 0h13.477l4.143 13.846 1.922 1.23L-65.694 0h13.474l-8.315 22.01 11.014 7.056h10.78L-47.435 0h13.481l8.686 29.066h12.438z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 414.72 191.77)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c21540",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.679c24.616 30.669 38.344 39.449 60.618 45.3C38.17 41.475 22.58 25.346 0 0",
    style: {
      fill: "#c21540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 296.923 191.77)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.993-9.887H-7.32l4.493 14.83h-3.709l-4.489-14.83h-4.329L-12.358 0h-3.707l-3.2-10.567c-.203-.661-.159-1.226.129-1.701.289-.474.806-.71 1.549-.71h12.42l1.863 2.063-.812-2.682h3.704L3.711 0Zm17.397 3.706-5.238-17.303h3.703l5.242 17.303ZM10.612 3.7 8.154-4.463c-1.156-3.815-1.851-5.448-2.62-6.7-.759-1.414-2.089-2.833-4.014-4.251-.766-.596-1.085-.897-.951-.897-.018-.053 1.26.247 2.496.897 2.456 1.255 4.233 2.617 5.329 4.088 1.223 1.471 2.338 3.76 3.341 6.865l2.57 8.161zm13.583.006-5.991-19.77h3.71l5.987 19.77z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 742.081 230.925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-8.264l2.507 8.266h8.263zm6.243 8.915c.19.631.152 1.172-.127 1.622-.275.453-.765.682-1.481.682H-6.104a2.877 2.877 0 0 1-1.889-.682c-.549-.45-.921-.991-1.109-1.622L-12.003-.65c-.191-.63-.148-1.172.125-1.623.274-.453.768-.681 1.481-.681H.349c.71 0 1.34.228 1.89.681.547.451.915.993 1.107 1.623z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 482.83 269.264)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.664 2.953H-9.202a2.878 2.878 0 0 1-1.89-.682c-.549-.45-.919-.991-1.111-1.622L-15.1-8.916c-.191-.63-.147-1.172.128-1.623.274-.452.767-.681 1.48-.681l11.864.002.893 2.952h-10.624L-8.857 0Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 286.782 234.273)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.188-.63-.147-1.172.127-1.621.275-.453.769-.681 1.479-.681h1.241v-.002h8.263l-.892-2.949H-1.588l-.895-2.954h13.046c.712 0 1.34.228 1.889.683.55.449.92.991 1.111 1.622l1.287 4.251c.191.63.148 1.171-.127 1.622-.274.453-.768.678-1.478.678L3.741.651l.714 2.358h9.446l2.664 2.955H4.111a2.886 2.886 0 0 1-1.89-.682c-.55-.45-.918-.991-1.109-1.622Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 10.511 247.019)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.692-5.594h-8.265L-8.266 0h-3.541l-4.29-14.171h3.544l1.701 5.625h7.083l1.778 1.97-2.302-7.595h3.545L3.541 0Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 355.533 221.772)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-1.253-4.132h-8.266L-8.265 0Zm3.737.649c.191.631.15 1.172-.125 1.622-.276.454-.768.682-1.479.682H-8.613c-.71 0-1.34-.228-1.887-.682-.551-.45-.919-.991-1.11-1.622l-3.595-11.867h3.543l1.251 4.137h7.083l1.775 1.967-1.846-6.104H.145z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 136.838 234.273)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-2.033c-1.794 0-2.769.614-3.438 2.296-.668 1.686-2.938 8.92-2.938 8.92L-11.805 0h-3.543l4.292 14.171h2.121c1.936 0 2.752-.794 3.318-2.185.565-1.392 2.971-9.036 2.971-9.036L.751 14.171h3.54z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 209.913 281.762)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-2.031c-1.795 0-2.771.614-3.443 2.296-.664 1.686-2.937 8.92-2.937 8.92L-11.804 0h-3.543l4.288 14.171h2.123c1.933 0 2.75-.794 3.319-2.185.565-1.392 2.971-9.036 2.971-9.036L.749 14.171h3.54z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 566.518 281.762)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#144999",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.194-.63-.153-1.172.123-1.623.276-.452.768-.681 1.481-.681l12.518.002.891 2.952H3.736l.809 2.673h10.04l.893 2.952H5.439l.8 2.641h11.28l.896 2.953H5.894c-.71 0-1.339-.228-1.888-.681-.549-.451-.921-.992-1.11-1.623Z",
    style: {
      fill: "#144999",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(4.23334 0 0 -4.23334 362.056 272.018)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKtxSancheonLogo);
export default __webpack_public_path__ + "static/media/KTX_SANCHEON_logo.32ca8b344d04e942cddd9f7bc8e75ff6.svg";
export { ForwardRef as ReactComponent };